import kboLogoLight from "@/assets/kbo-logo-white.png";
import kboLogoDark from "@/assets/kbo-logo-black.png";
import neositekLogo from "@/assets/neositek-logo.png";
import smallKboLogo from "@/assets/kbo-logo-sidebar.png";
import { isNeositek } from "@/utils/neositek";

export default {
  computed: {
    isNeositek() {
      return isNeositek();
    },
    lightLogo() {
      if (this.isNeositek) {
        return neositekLogo;
      } else {
        return kboLogoLight;
      }
    },
    darkLogo() {
      if (this.isNeositek) {
        return neositekLogo;
      } else {
        return kboLogoDark;
      }
    },
    smallLogo() {
      if (this.isNeositek) {
        return neositekLogo;
      } else {
        return smallKboLogo;
      }
    },
    flavourName() {
      if (this.isNeositek) {
        return "Neositek";
      } else {
        return "KBO";
      }
    },
  },
};
